/**
 * Load Google reCAPTCHA only on routes that need it (auth, add entry).
 * Avoids ~380 KB on dictionary and other public pages.
 */
let loadPromise = null

export function loadRecaptchaScript () {
  if (typeof window !== 'undefined' && window.grecaptcha) {
    return Promise.resolve()
  }
  if (loadPromise) {
    return loadPromise
  }

  loadPromise = new Promise((resolve, reject) => {
    window.vueRecaptchaApiLoaded = () => resolve()
    const script = document.createElement('script')
    script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
    script.async = true
    script.defer = true
    script.onerror = () => reject(new Error('reCAPTCHA failed to load'))
    document.head.appendChild(script)
  })

  return loadPromise
}

export function needsRecaptchaScript (siteKey) {
  return !!(siteKey && siteKey !== 'secretKey')
}
